import { render } from "./IntegrationSearch.vue?vue&type=template&id=639dba6a&scoped=true"
import script from "./IntegrationSearch.vue?vue&type=script&lang=js"
export * from "./IntegrationSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639dba6a"]])

export default __exports__